import { render, staticRenderFns } from "./ProjectValuationExternalReportPage6.vue?vue&type=template&id=4b71c5d6&"
import script from "./ProjectValuationExternalReportPage6.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationExternalReportPage6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports